var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "39px",
    viewBox: "0 0 34 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DD17D5F0-2A58-48BF-BBA2-710AA17CF7E8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legal-statements-svg-icons",
    transform: "translate(-78.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-137",
    transform: "translate(79.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-96-Copy-2",
    stroke: "#788999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2397505,4.83600012 L27.9720015,4.83600012 C28.523734,4.83600012 28.9710015,5.28326768 28.9710015,5.83500018 L28.9710015,34.8060017 C28.9710015,36.4611992 27.6291988,37.8030019 25.9740014,37.8030019 L4.99500026,37.8030019 C4.44326777,37.8030019 3.99600021,37.3557343 3.99600021,36.8040018 L3.99600021,11.0730005 L3.99600021,11.0730005 L10.2397505,4.83600012 Z",
    id: "Rectangle",
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24175043,2.83800002 L25.9740014,2.83800002 C26.5257339,2.83800002 26.9730014,3.28526758 26.9730014,3.83700007 L26.9730014,33.8070016 C26.9730014,34.9104666 26.0784663,35.8050018 24.9750013,35.8050018 L2.99700016,35.8050018 C2.44526766,35.8050018 1.99800011,35.3577342 1.99800011,34.8060017 L1.99800011,9.07500035 L1.99800011,9.07500035 L8.24175043,2.83800002 Z",
    id: "Rectangle",
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24375033,0.839999914 L23.9760013,0.839999914 C24.5277338,0.839999914 24.9750013,1.28726747 24.9750013,1.83899997 L24.9750013,32.8080016 C24.9750013,33.3597341 24.5277338,33.8070016 23.9760013,33.8070016 L0.999000053,33.8070016 C0.447267558,33.8070016 2.02771532e-15,33.3597341 0,32.8080016 L0,7.07700024 L0,7.07700024 L6.24375033,0.839999914 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99400032,0.839999914 L5.99400032,5.83500018 C5.99400032,6.38673267 5.54673276,6.83400023 4.99500026,6.83400023 L0,6.83400023 L0,6.83400023 L5.99400032,0.839999914 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 3.99600021,
    y: 11.8290005,
    width: 16.9830009,
    height: 17.9820009,
    rx: 0.999000053
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.49550024,
    y1: 14.8260007,
    x2: 20.4795011,
    y2: 14.8260007,
    id: "Line-32",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.49550024,
    y1: 17.8230008,
    x2: 20.4795011,
    y2: 17.8230008,
    id: "Line-32-Copy",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.49550024,
    y1: 20.820001,
    x2: 20.4795011,
    y2: 20.820001,
    id: "Line-32-Copy-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.49550024,
    y1: 26.8140013,
    x2: 20.4795011,
    y2: 26.8140013,
    id: "Line-32-Copy-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.49550024,
    y1: 23.8170011,
    x2: 20.4795011,
    y2: 23.8170011,
    id: "Line-32-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.49250039,
    y1: 12.3285005,
    x2: 7.49250039,
    y2: 29.3115014,
    id: "Line-33",
    fill: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.4825009,
    y1: 11.8290005,
    x2: 17.4825009,
    y2: 28.8120014,
    id: "Line-33",
    fill: "#FFFFFF",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-125",
    transform: "translate(17.500000, 16.500000) rotate(-5.000000) translate(-17.500000, -16.500000) translate(4.000000, 3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5600003,19.1200006 C15.7352732,19.1200006 19.1200006,15.7352732 19.1200006,11.5600003 C19.1200006,7.76491926 16.3236213,4.62296761 12.6789526,4.0822353 C12.3138291,4.02806464 11.9401921,4 11.5600003,4 C7.38472743,4 4,7.38472743 4,11.5600003 C4,15.7352732 7.38472743,19.1200006 11.5600003,19.1200006 Z",
    id: "Oval",
    stroke: "#788999",
    strokeWidth: 1.08000004,
    transform: "translate(11.560000, 11.560000) rotate(45.000000) translate(-11.560000, -11.560000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5600003,6.16000009 C9.23072874,6.16000009 7.24590656,7.63476316 6.48833367,9.70148938",
    id: "Path",
    stroke: "#E7EAF3",
    strokeWidth: 1.08000004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.2763252,
    y1: 17.2763252,
    x2: 25.9163255,
    y2: 25.9163255,
    id: "Line-31",
    stroke: "#788999",
    strokeWidth: 1.08000004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.9763253,
    y1: 19.9763253,
    x2: 25.9163255,
    y2: 25.9163255,
    id: "Line-31",
    stroke: "#788999",
    strokeWidth: 3.24000013,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-10-Copy-11",
    stroke: "#788999",
    strokeWidth: 2.16000009,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(11.560000, 12.100000) rotate(5.000000) translate(-11.560000, -12.100000) ",
    points: "8.32000017 12.1000003 10.5445344 14.8000004 14.8000004 9.40000021"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/filesIcon.6635f66909edbae30d916f922e4a0382.svg";
export { ForwardRef as ReactComponent };